import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import GreenlineLayout from './GreenlineLayout';
import GreenlineHome from './pages/GreenlineHome';
import GreenlineKitchens from './pages/GreenlineKitchens';
import GreenlineBathrooms from './pages/GreenlineBathrooms';
import GreenlineCarpentry from './pages/GreenlineCarpentry';
import GreenlineBasements from './pages/GreenlineBasements';
import GreenlineContact from './pages/GreenlineContact';

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
      <Routes>
        <Route path="/" element={<GreenlineLayout />}>
          <Route index element={<GreenlineHome />} />
          <Route path="kitchens" element={<GreenlineKitchens />} />
          <Route path="bathrooms" element={<GreenlineBathrooms />} />
          <Route path="carpentry" element={<GreenlineCarpentry />} />
          <Route path="basements" element={<GreenlineBasements />} />
          <Route path="contact" element={<GreenlineContact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
